var SelectOptions = require("components/utility/SelectOptions");

require("utility/auto_submit_text_area.scss")

class AutoSubmitTextArea extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		var value = props.defaultValue || (props.numbersOnly ? undefined : "");
		this.state = { value: value };
	}

	onChange(event) {
		this.setState({ value: event.target.value });
	}

	selectPrefill(option) {
		this.setState({ value: option.label })

		setTimeout(() => {
			this.checkShowEnterLine();			
		}, 50);
	}

	onKeyDown(e) {
		if (e.keyCode == 13) {
			$wr.nope(e)
			this.props.onSubmit(e);
		}
	}

	checkShowEnterLine(e) {
		var text = this.text();
		var $line = $(this.refs.enterLine);

		if (text.length == 0) {
			$line.addClass("hideLine");
		} else {
			$line.removeClass("hideLine");
		}
	}

	focus() {
		if (this.props.numbersOnly) {
			this.refs.numberInput.refs.textfield.focus();
		} else {
			this.refs.textarea.focus();
		}
	}

	text() {
		return this.state.value;
	}

	setText(text) {
		this.setState({ value: text });
	}

	reset() {
		this.setState({ value: "" });
	}

	render() {
		var link;
		if (this.props.submitLink) {
			link = (
				<p ref="enterLine">
					<a href="#" onMouseDown={ this.props.onSubmit } onClick={ $wr.preventDefaultBehavior }>
						Press enter
					</a> to submit.
				</p>
			);
		}

		var inputProps = _.omit(this.props, "numbersOnly", "submitLink", "onSubmit", "prefillOptions");

		if (this.props.numbersOnly) {
			var input = (
				<NumbersOnlyInput { ...inputProps } value={ this.state.value } onKeyDown={ this.onKeyDown }
					onChange={ this.onChange } onKeyUp={ this.checkShowEnterLine } ref="numberInput" />
			)
		} else {
			var input = (
				<textarea { ...inputProps } value={ this.state.value } onKeyDown={ this.onKeyDown }
					onChange={ this.onChange } onKeyUp={ this.checkShowEnterLine } ref="textarea" />
			)
		}

		if (this.props.prefillOptions) {
			
			var prefillSelect = (
				<SelectOptions onSelect={ this.selectPrefill } value={ this.state.value }
					options={ this.props.prefillOptions } hideFullMatch={ true } />
			);
		}

		return (
			<div className="autoSubmitTextArea">
				{ input }
				{ prefillSelect }
				{ link }
			</div>
		)
	}

	componentDidMount() {
		this.checkShowEnterLine();
	}
};

AutoSubmitTextArea.propTypes = StrictPropTypes({
	// If true, only allow numbers to be typed
	numbersOnly: PropTypes.bool,

	// If true, show a link to allow submitting
	submitLink: PropTypes.bool,

	// Function to call after enter is pressed or submit link is clicked
	onSubmit: PropTypes.func,

	// Class passed through to input/textarea
	className: PropTypes.string,

	// Value text passed through to input/textarea
	defaultValue: PropTypes.string,

	// Placeholder text passed through to input/textarea
	placeholder: PropTypes.string,

	// A collection of options 
	prefillOptions: PropTypes.array,

	// Also passed through to input/textaread
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,

});

module.exports = AutoSubmitTextArea;



// WEBPACK FOOTER //
// ./modules/components/utility/AutoSubmitTextArea.js